<ng-container *ngIf="visible">
  <button
    *ngIf="!open"
    type="button"
    class="help-bot-launcher"
    [class.is-asking]="nudgeVisible"
    (click)="openPanel()"
    [attr.aria-label]="launcherLabel"
    [attr.title]="launcherLabel"
  >
    <span class="help-bot-launcher-face">
      <ng-container *ngTemplateOutlet="rioFace"></ng-container>
    </span>
    <span *ngIf="nudgeVisible" class="help-bot-nudge">Ask Rio</span>
    <span *ngIf="unreadCount > 0" class="help-bot-badge">{{ unreadCount }}</span>
  </button>

  <section
    *ngIf="open"
    class="help-bot-panel"
    [class.is-expanded]="panelExpanded"
    role="dialog"
    aria-label="Rio"
  >
    <header class="help-bot-header" [class.is-home-header]="view === 'categories'">
      <div class="help-bot-header-side help-bot-header-left">
        <button
          *ngIf="view !== 'categories'"
          type="button"
          class="help-bot-back"
          (click)="back()"
          title="Back"
          aria-label="Back"
        >
          <i class="fas fa-chevron-left" aria-hidden="true"></i>
        </button>
      </div>

      <div class="help-bot-title-block">
        <div
          *ngIf="view === 'categories'"
          class="help-bot-avatar-stack help-bot-header-avatars"
          aria-hidden="true"
        >
          <span class="help-bot-avatar help-bot-avatar-a">A</span>
          <span class="help-bot-avatar help-bot-avatar-b">S</span>
          <span class="help-bot-avatar help-bot-avatar-c">T</span>
          <span class="help-bot-avatar help-bot-avatar-rio">
            <ng-container *ngTemplateOutlet="rioFace"></ng-container>
          </span>
        </div>
        <ng-container *ngIf="view !== 'categories'">
          <h2 class="help-bot-title">{{ panelTitle }}</h2>
          <p *ngIf="panelSubtitle" class="help-bot-title-sub">{{ panelSubtitle }}</p>
        </ng-container>
      </div>

      <div class="help-bot-header-side help-bot-header-right">
        <div class="help-bot-menu" *ngIf="showThreadChrome || view === 'categories'">
          <button
            type="button"
            class="help-bot-icon-btn"
            title="More"
            aria-label="More"
            aria-haspopup="menu"
            [attr.aria-expanded]="menuOpen"
            (click)="toggleMenu($event)"
          >
            <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
          </button>
          <div *ngIf="menuOpen" class="help-bot-menu-panel" role="menu">
            <p class="help-bot-menu-heading">Quick Actions</p>
            <button
              type="button"
              class="help-bot-menu-item"
              role="menuitem"
              (click)="minimizeChat()"
            >
              <i class="fas fa-times" aria-hidden="true"></i>
              <span>Minimize chat</span>
            </button>
            <button
              type="button"
              class="help-bot-menu-item"
              role="menuitem"
              (click)="toggleExpandedView()"
            >
              <i
                class="fas"
                [class.fa-expand-alt]="!panelExpanded"
                [class.fa-compress-alt]="panelExpanded"
                aria-hidden="true"
              ></i>
              <span>{{ panelExpanded ? 'Collapse view' : 'Expand view' }}</span>
            </button>
            <button
              type="button"
              class="help-bot-menu-item"
              role="menuitem"
              (click)="startNewChat()"
              [disabled]="startingChat"
            >
              <i class="fas fa-plus-circle" aria-hidden="true"></i>
              <span>New conversation</span>
            </button>
            <button
              *ngIf="canCloseChat"
              type="button"
              class="help-bot-menu-item"
              role="menuitem"
              (click)="closeChat()"
              [disabled]="closingChat"
            >
              <i class="fas fa-check-circle" aria-hidden="true"></i>
              <span>Close chat</span>
            </button>
            <button
              type="button"
              class="help-bot-menu-item"
              role="menuitem"
              (click)="openHistory()"
            >
              <i class="fas fa-history" aria-hidden="true"></i>
              <span>Chat history</span>
            </button>
          </div>
        </div>

        <button
          type="button"
          class="help-bot-close"
          (click)="closePanel()"
          aria-label="Close"
        >
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </header>

    <div
      class="help-bot-body"
      [class.is-home]="view === 'categories'"
      #panelBody
    >
      <p *ngIf="loading" class="help-bot-status">Loading topics…</p>

      <div *ngIf="!loading && error && view === 'categories'" class="help-bot-status">
        <p>{{ error }}</p>
        <button type="button" class="help-bot-retry" (click)="loadTemplates()">
          Try again
        </button>
      </div>

      <div
        *ngIf="!loading && !error && view === 'categories'"
        class="help-bot-home"
      >
        <div class="help-bot-home-hero">
          <p class="help-bot-greeting">Questions? Chat with us.</p>
          <p class="help-bot-reply-status">
            <span class="help-bot-online-dot" aria-hidden="true"></span>
            Typically replies under an hour.
          </p>
        </div>

        <div class="help-bot-home-chat">
          <div class="help-bot-intro" aria-label="Rio greeting">
            <span class="help-bot-intro-avatar" aria-hidden="true">
              <ng-container *ngTemplateOutlet="rioFace"></ng-container>
            </span>
            <p class="help-bot-intro-bubble">How can we help with Rio?</p>
          </div>

          <p
            *ngIf="categories.length === 0"
            class="help-bot-status"
          >
            No topics are available.
          </p>
          <p
            *ngIf="categories.length > 0 && !showingMatchedQuestions && suggestionChips.length === 0 && !showSearchesChip"
            class="help-bot-status"
          >
            No topics are available.
          </p>

          <div class="help-bot-home-suggestions">
            <div class="help-bot-chips" *ngIf="showingMatchedQuestions">
              <button
                type="button"
                class="help-bot-chip help-bot-chip-question"
                *ngFor="let row of matchedQuestionChips"
                (click)="selectMatchedItem(row)"
              >
                {{ row.item.question }}
              </button>
            </div>

            <div
              class="help-bot-chips"
              *ngIf="!showingMatchedQuestions && (suggestionChips.length > 0 || showSearchesChip)"
            >
              <button
                type="button"
                class="help-bot-chip"
                *ngFor="let category of suggestionChips"
                (click)="selectCategory(category)"
              >
                {{ category.title }}
              </button>
              <button
                *ngIf="showSearchesChip"
                type="button"
                class="help-bot-chip help-bot-chip-searches"
                (click)="openSearchTopics()"
              >
                {{ searchesChipLabel }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="!loading && !error && view === 'searches'"
        class="help-bot-chips help-bot-questions help-bot-searches"
      >
        <p
          *ngIf="searchTopicCategories.length === 0"
          class="help-bot-status help-bot-questions-empty"
        >
          No search products are enabled on your plan.
        </p>
        <button
          type="button"
          class="help-bot-chip help-bot-chip-question"
          *ngFor="let category of searchTopicCategories"
          (click)="selectCategory(category)"
        >
          {{ category.title }}
        </button>
      </div>

      <div
        *ngIf="!loading && !error && view === 'questions'"
        class="help-bot-chips help-bot-questions"
      >
        <p
          *ngIf="questionItems.length === 0"
          class="help-bot-status help-bot-questions-empty"
        >
          No questions are available for this topic.
        </p>
        <button
          type="button"
          class="help-bot-chip help-bot-chip-question"
          *ngFor="let item of questionItems"
          (click)="selectItem(item)"
        >
          {{ item.question }}
        </button>
      </div>

      <div
        *ngIf="!loading && !error && view === 'answer' && selectedItem"
        class="help-bot-answer-wrap"
      >
        <div class="help-bot-answer-header">
          <p class="help-bot-question">{{ selectedItem.question }}</p>
        </div>
        <p class="help-bot-answer">{{ selectedItem.answer }}</p>
        <a
          *ngIf="pageRoute(selectedItem) as route"
          class="help-bot-page-link"
          [routerLink]="route"
        >
          Open this page
        </a>
        <button
          type="button"
          class="help-bot-escalate"
          (click)="escalateToAdmin()"
        >
          Still need help? Chat with admin
        </button>
      </div>

      <div *ngIf="view === 'history'" class="help-bot-history">
        <p *ngIf="historyLoading" class="help-bot-status">Loading chat history…</p>

        <div *ngIf="!historyLoading && historyError" class="help-bot-status">
          <p>{{ historyError }}</p>
          <button type="button" class="help-bot-retry" (click)="loadHistory()">
            Try again
          </button>
        </div>

        <p
          *ngIf="!historyLoading && !historyError && historyItems.length === 0"
          class="help-bot-status"
        >
          No chats yet.
        </p>

        <button
          type="button"
          class="help-bot-history-item"
          *ngFor="let item of historyItems; trackBy: trackHistory"
          (click)="selectHistoryItem(item)"
        >
          <span class="help-bot-history-preview">{{ historyLabel(item) }}</span>
          <span class="help-bot-history-meta">
            <span
              class="help-bot-history-status"
              [class.is-closed]="item.status === 'closed'"
            >
              {{ item.status === 'closed' ? 'Closed' : 'Open' }}
            </span>
            <span *ngIf="historyWhen(item) as when" class="help-bot-history-when">
              {{ when }}
            </span>
          </span>
        </button>
      </div>

      <div *ngIf="view === 'thread'" class="help-bot-thread">
        <div
          *ngIf="!threadLoading && !threadError"
          class="help-bot-intro help-bot-thread-intro"
          aria-label="Rio greeting"
        >
          <span class="help-bot-intro-avatar" aria-hidden="true">
            <ng-container *ngTemplateOutlet="rioFace"></ng-container>
          </span>
          <p class="help-bot-intro-bubble">How can we help with Rio?</p>
        </div>

        <p *ngIf="threadLoading && messages.length === 0" class="help-bot-status">
          Loading messages…
        </p>

        <div
          *ngIf="!threadLoading && threadError && messages.length === 0"
          class="help-bot-status"
        >
          <p>{{ threadError }}</p>
          <button
            *ngIf="conversationId"
            type="button"
            class="help-bot-retry"
            (click)="loadMessages()"
          >
            Try again
          </button>
          <button
            *ngIf="!conversationId"
            type="button"
            class="help-bot-retry"
            (click)="startNewChat()"
          >
            Try again
          </button>
        </div>

        <p
          *ngIf="!threadLoading && !threadError && messages.length === 0 && conversationStatus === 'closed'"
          class="help-bot-status"
        >
          This chat is closed.
        </p>

        <ng-container *ngFor="let row of threadRows; trackBy: trackThreadRow">
          <p *ngIf="row.kind === 'date'" class="help-bot-date-sep">
            {{ row.label }}
          </p>
          <div
            *ngIf="row.kind === 'message'"
            class="help-bot-message"
            [class.help-bot-message-own]="isOwnMessage(row.message.sender)"
          >
            <div class="help-bot-message-header">
              <p
                *ngIf="senderLabel(row.message.sender) as label"
                class="help-bot-sender"
              >
                {{ label }}
              </p>
            </div>
            <p *ngIf="row.message.body" class="help-bot-message-body">
              {{ row.message.body }}
            </p>
            <div
              *ngIf="row.message.attachment_url"
              class="help-bot-attachment"
            >
              <a
                *ngIf="isImageAttachment(row.message)"
                class="help-bot-attachment-image-link"
                [href]="row.message.attachment_url"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="help-bot-attachment-image"
                  [src]="row.message.attachment_url"
                  [alt]="row.message.attachment_name || 'Attachment'"
                />
              </a>
              <audio
                *ngIf="isAudioAttachment(row.message)"
                class="help-bot-attachment-audio"
                controls
                preload="metadata"
                [src]="row.message.attachment_url"
              >
                Your browser does not support audio playback.
              </audio>
              <a
                *ngIf="!isImageAttachment(row.message) && !isAudioAttachment(row.message)"
                class="help-bot-attachment-file"
                [href]="row.message.attachment_url"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fas fa-paperclip" aria-hidden="true"></i>
                <span>{{ row.message.attachment_name || 'Download attachment' }}</span>
              </a>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <form
      *ngIf="showComposer"
      class="help-bot-composer"
      [class.help-bot-composer-home]="view === 'categories'"
      (submit)="sendMessage($event)"
    >
      <div class="help-bot-composer-box">
        <div
          *ngIf="showAttachChip"
          class="help-bot-attach-card"
          [class.is-uploading]="attachUploading"
        >
          <span *ngIf="attachUploading" class="help-bot-attach-card-status">
            Uploading…
          </span>
          <ng-container *ngIf="!attachUploading && pendingAttachDisplayName">
            <span class="help-bot-attach-card-icon" aria-hidden="true">
              <i class="fas fa-paperclip"></i>
            </span>
            <span class="help-bot-attach-card-meta">
              <span class="help-bot-attach-chip-name help-bot-attach-card-name">
                {{ pendingAttachDisplayName }}
              </span>
              <span class="help-bot-attach-card-type">{{ pendingAttachTypeLabel }}</span>
            </span>
            <button
              type="button"
              class="help-bot-attach-chip-remove help-bot-attach-card-remove"
              aria-label="Remove attachment"
              (click)="clearPendingAttachment($event)"
            >
              ×
            </button>
          </ng-container>
        </div>
        <textarea
          #composerInput
          class="help-bot-input"
          [attr.rows]="view === 'categories' ? 1 : 2"
          aria-label="Message"
          [attr.placeholder]="composerPlaceholder"
          [value]="draft"
          (input)="onDraftInput($event)"
          (keydown)="onComposerKeydown($event)"
        ></textarea>
        <div class="help-bot-composer-toolbar">
          <div class="help-bot-composer-tools">
            <div class="help-bot-emoji-wrap">
              <button
                type="button"
                class="help-bot-composer-tool is-interactive"
                title="Emoji"
                aria-label="Insert emoji"
                aria-haspopup="dialog"
                [attr.aria-expanded]="emojiPickerOpen"
                (click)="toggleEmojiPicker($event)"
              >
                <i class="far fa-smile" aria-hidden="true"></i>
              </button>
              <div
                *ngIf="emojiPickerOpen"
                class="help-bot-emoji-picker"
                role="listbox"
                aria-label="Emoji picker"
              >
                <button
                  *ngFor="let emoji of emojiSet"
                  type="button"
                  class="help-bot-emoji-option"
                  role="option"
                  [attr.aria-label]="emoji"
                  (click)="insertEmoji(emoji, $event)"
                >
                  {{ emoji }}
                </button>
              </div>
            </div>
            <ng-container *ngIf="showAttachControl">
              <button
                type="button"
                class="help-bot-composer-tool is-interactive"
                title="Attach file"
                aria-label="Attach file"
                [disabled]="sending || attachUploading"
                (click)="openAttachPicker($event)"
              >
                <i class="fas fa-paperclip" aria-hidden="true"></i>
              </button>
              <input
                #attachInput
                type="file"
                class="help-bot-attach-input"
                [attr.accept]="attachAccept"
                (change)="onAttachSelected($event)"
              />
            </ng-container>
            <button
              type="button"
              class="help-bot-composer-tool is-interactive"
              [class.is-listening]="speechListening"
              [attr.title]="dictateTitle"
              [attr.aria-label]="dictateAriaLabel"
              [attr.aria-pressed]="speechListening"
              [disabled]="!speechSupported || sending || attachUploading || voiceNoteRecording"
              (click)="toggleSpeechDictation($event)"
            >
              <i class="fas fa-microphone" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="help-bot-composer-tool is-interactive"
              [class.is-listening]="voiceNoteRecording"
              [attr.title]="micTitle"
              [attr.aria-label]="micAriaLabel"
              [attr.aria-pressed]="voiceNoteRecording"
              [disabled]="!voiceNoteSupported || sending || attachUploading || speechListening"
              (click)="toggleVoiceNote($event)"
            >
              <svg
                class="help-bot-voice-wave-icon"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <rect x="2.5" y="9" width="2.4" height="6" rx="1.2" />
                <rect x="7" y="6" width="2.4" height="12" rx="1.2" />
                <rect x="11.5" y="3.5" width="2.4" height="17" rx="1.2" />
                <rect x="16" y="6" width="2.4" height="12" rx="1.2" />
                <rect x="20.5" y="9" width="2.4" height="6" rx="1.2" />
              </svg>
            </button>
          </div>
          <button type="submit" class="help-bot-send" [disabled]="!canSend" aria-label="Send">
            <i class="fas fa-paper-plane" aria-hidden="true"></i>
            <span class="help-bot-send-label">Send</span>
          </button>
        </div>
      </div>
      <p *ngIf="composerVoiceStatus" class="help-bot-status" aria-live="polite">{{ composerVoiceStatus }}</p>
      <p *ngIf="attachError" class="help-bot-status">{{ attachError }}</p>
      <p *ngIf="sendError" class="help-bot-status">{{ sendError }}</p>
    </form>

    <p
      *ngIf="view === 'thread' && conversationStatus === 'closed' && sendError"
      class="help-bot-composer-note help-bot-status"
    >
      {{ sendError }}
    </p>
  </section>

  <ng-template #rioFace>
    <svg class="help-bot-face" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <path d="M14 36c0-14 7-24 18-24s18 10 18 24" fill="#2b9aa8" />
      <rect x="7" y="30" width="8" height="13" rx="4" fill="#12686e" />
      <rect x="49" y="30" width="8" height="13" rx="4" fill="#12686e" />
      <path d="M17 38c0-12 6-20 15-20s15 8 15 20" fill="#ffe45c" />
      <rect x="12" y="27" width="40" height="26" rx="13" fill="#f0c400" />
      <rect x="16" y="31" width="32" height="18" rx="9" fill="#1c2a32" />
      <path d="M22 42c1.5-4 3.6-6 6-6s4.5 2 6 6c-1.7-1.8-3.6-2.7-6-2.7s-4.3.9-6 2.7z" fill="#86e6f6" />
      <path d="M34 42c1.5-4 3.6-6 6-6s4.5 2 6 6c-1.7-1.8-3.6-2.7-6-2.7s-4.3.9-6 2.7z" fill="#86e6f6" />
    </svg>
  </ng-template>
</ng-container>
